import styled from "styled-components"
import { useParams, useHistory } from "react-router-dom"
import { BackButton, CustomButton, Card } from "../../components"
import { COLORS } from "../../constants"
import soon from "../../assets/images/soon.svg"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import axios from 'axios';
import logo from "../../assets/images/logo.png"
import font from "../../assets/fonts/FredokaOne-Regular.ttf"

import {
    PDFDownloadLink,
    Document,
    Page,
    View,
    Text,
    BlobProvider,
    StyleSheet,
    Image,
    Font
}
    from '@react-pdf/renderer';

const StyledCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 10px;
`;
const StyledCardWrapper = styled.div`
    padding: 5px;
`;
Font.register({ family: 'Fredoka One', src: font });

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Fredoka One',
        fontSize: 13,
        paddingTop: 30,
        paddingLeft: 60,
        paddingRight: 60,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    logo: {
        width: '170px',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    section: {
        marginTop: 10
    },
    input: {
        backgroundColor: '#f2f2f2',
        borderColor: '#d1d1d1',
        borderStyle: 'solid',
        borderWidth: 3,
        height: 40,
        borderRadius: 10,
        width: "50%",
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 10,
        justifyContent: 'center',
        paddingLeft: 10
    },
    circle: {
        backgroundColor: COLORS.green,
        borderRadius: "50%",
        width: 20,
        height: 20,
        color: COLORS.text_dark_green,
        justifyContent: 'center',
        alignItems: 'center'

    }
});
function MyDoc({ levelno, gameno, data, withAnswers }) {
    useEffect(() => {
        console.log(data)
    }, [])
    return (
        <Document>
            <Page style={styles.page}>
                <View style={{ textAlign: 'center' }}>
                    <Image style={styles.logo} src={logo} />
                    <Text style={{ color: COLORS.text_green, fontSize: 16 }}>Level {levelno} • Game {gameno}</Text>
                </View>
                <View style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: 20 }}>
                    <Text style={{ width: "50%" }}>Name: .....................................................</Text>
                    <Text style={{ width: "50%" }}>Date: .....................................................</Text>
                </View>
                <View style={{ marginTop: 20 }}>
                    {data.map((entry, i) => {
                        return (
                            <View key={i} style={styles.section}>

                                <View style={styles.circle}>
                                    <Text style={{ fontSize: 13 }}>{i + 1}</Text>
                                </View>
                                <Text style={{ color: COLORS.text_green, textAlign: "center", marginTop: "-17" }}>{entry.type} • {entry.word.length} Letters • first letter is {entry.word.charAt(0).toUpperCase()}</Text>

                                <Text style={{ textAlign: "center" }}>{entry.clue}</Text>
                                <View style={styles.input}>
                                    {withAnswers && <Text style={{ textAlign: "center" }}>{entry.word}</Text>}

                                </View>
                            </View>
                        )
                    })}
                </View>
            </Page>
        </Document>
    );
}

export default function Games() {
    const api = process.env.REACT_APP_API_URL;
    const history = useHistory();
    const user = useSelector(state => state.auth.user.user);
    const [gameGenerated, setGameGenerated] = useState(0);

    let { levelno } = useParams();
    const [data, setData] = useState([]);
    const [gameQuestions, setGameQuestions] = useState([]);
    const [withAnswers, setWithAnswers] = useState(false);

    const handlePrint = (event) => {
        event.preventDefault();

    };
    useEffect(async () => {
        const response = await axios.get(`${api}/ps/puchased_games/${user.email}`);
        const data = response.data.levels;
        setData(data.find(element => element.level_no == levelno).games)

    }, []);
    const generatePdf = (levelno, gameno, withAnswers) => {

        axios.get(`${api}/qt/questions/${levelno}/${gameno}`, {}, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            const result = res.data;
            setWithAnswers(withAnswers)
            setGameQuestions(result);
            setGameGenerated(gameno);


        }).catch(error => {
            console.log(error);
        });

    }
    return (
        <div>
            <BackButton onClick={() => history.push('/dashboard')} />
            <h5 className="color-text-green text-center">Level {levelno} Games</h5>
            <h6 className="color-text-grey text-center mt-1">Here you can view and download worksheets for your class</h6>
            <ul className="list-unstyled">
                {data.map((entry, i) => {
                    return <li key={i} className="w-100 mb-3">
                        <Card className="w-100" style={{ paddingTop: 40, paddingBottom: 40 }}>
                            <div className="d-flex">
                                <div className="flex-grow-1">
                                    <h5 className="color-text-dark-green">Game {entry.game_no}</h5>
                                    <div className="color-text-grey">Print off Level {levelno} • Game {entry.game_no} questions</div>
                                </div>
                                <div className="d-flex align-items-center">
                                    {/* Hide Buttons when PDF is generated */}
                                    {gameGenerated != entry.game_no && <div className="justify-content-end d-flex flex-wrap">
                                        <CustomButton bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ fontSize: 15 }} className="px-3" onClick={() => generatePdf(levelno, entry.game_no, false)}>
                                            PDF • No Answers
                                    </CustomButton>
                                        <CustomButton bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.darker_green} style={{ marginLeft: 10, fontSize: 15 }} className="px-3" onClick={() => generatePdf(levelno, entry.game_no, true)}>
                                            PDF • Answers
                                    </CustomButton>
                                    </div>
                                    }
                                    {/* Show button to review the PDF file */}

                                    {gameGenerated == entry.game_no ?
                                        <div className="justify-content-end d-flex flex-wrap">
                                            <BlobProvider document={<MyDoc levelno={levelno} gameno={entry.game_no} data={gameQuestions} withAnswers={withAnswers} />}>
                                                {({ url }) => (
                                                    <a href={url} target="_blank">
                                                        <CustomButton bgColor={COLORS.level_six} color={COLORS.level_six_text} hover='#DDC600' className="px-3 animation" onClick={() => generatePdf(levelno, entry.game_no, withAnswers)}>
                                                            View PDF
                                                    </CustomButton>
                                                    </a>
                                                )}
                                            </BlobProvider>
                                            <CustomButton bgColor="#FF3366" color="#641528" hover="#e32d5b" style={{ fontSize: 15 }} className="px-3 ml-3" onClick={() => {
                                                setWithAnswers(false);
                                                setGameGenerated(0);
                                                setGameQuestions([])
                                            }}>
                                                Cancel
                                            </CustomButton>

                                        </div> : null

                                    }


                                </div>
                            </div>
                        </Card>
                    </li>
                })}

            </ul>
        </div >
    )
}
